import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Navigation from "../../components/Navigation";
import SideBar from "../../components/SideBar";
import Footer from "../../components/Footer";
import LogOutModal from "../../components/modals/LogOutModal";
import ContactUsModal from "../../components/modals/ContactUsModal";
import DashBoardStats from "../../components/stats/DashBoardStats";
import BarChart from "../../components/charts/BarChart";
import LineChart from "../../components/charts/LineChart";
import { accessBankToken, authanticatedUser, convertToAblDate } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getMyAblAccounts } from "../../redux/actions/accounts";
import { getCustomerStatement } from "../../redux/actions/statements";
import SetNewPasswordModal from "../../components/modals/SetNewPasswordModal";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Home = () => {
  const dispatch = useDispatch()
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState({});
  const { loading, accounts } = useSelector((state) => state.accounts);
  const { statementLoading, statement } = useSelector((state) => state.statement);
  const [newPassOpen, setNewPassOpen] = useState(true)

  const [dasAccount, setDashAccount] = useState({});
  const [activeDataset, setActiveDataset] = useState("both");

  let now = new Date();
  let start = new Date(now.getFullYear() - 1, now.getMonth() + 1, 1)
  let end = new Date(now.getFullYear(), now.getMonth() + 1, 0)


  const deposit = statement?.transactions?.filter(trans => trans.transactionType === "DEPOSIT");
  const withdrawal = statement?.transactions?.filter(trans => trans.transactionType === "WITHDRAWAL");

  useEffect(() => {
    dispatch(getMyAblAccounts({token: authanticatedUser.token, clientNumber: authanticatedUser.clientNumber, ablToken: accessBankToken}));
  }, []);

  useEffect(() => {
    if(accounts?.accounts){

      setDashAccount(accounts?.accounts[0])

      console.log(end)

      const tmpStat = {
        accountNumber: accounts?.accounts[0]?.internalAccountNumber,
        from: convertToAblDate(start),
        to: convertToAblDate(end),
        ablToken: accessBankToken,
        token: authanticatedUser?.token
      }
  
      dispatch(getCustomerStatement(tmpStat))
    }

    // console.log(convertToAblDate(start), convertToAblDate(end))
  }, [accounts?.accounts])

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setIsLogOutModalOpen(!isLogOutModalOpen);
  };

  const toggleContactUsModal = () => {
    setIsContactUsModalOpen(!isContactUsModalOpen);
  };

  const pageTitle = `${authanticatedUser?.name}`;
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "Dashboard" }];

  const handleAccountChange = (e) => {
    setSelectedAccount(e.target.value);
    // console.log(e.target.value)

    // if(accounts?.accounts){
    //   setDashAccount(accounts?.accounts[0])

    //   const tmpStat = {
    //     accountNumber: accounts?.accounts[0]?.internalAccountNumber,
    //     from: convertToAblDate(start),
    //     to: convertToAblDate(end),
    //     ablToken: accessBankToken,
    //     token: authanticatedUser?.token
    //   }
  
    //   dispatch(getCustomerStatement(tmpStat))
    // }
  };

  const selectDashboardAccount = (item) => {
    // 
    const account = JSON.parse(item);

    // console.log(account);
    setDashAccount(account);

    if(account.currency){

      const tmpStat = {
        accountNumber: account.internalAccountNumber,
        from: convertToAblDate(start),
        to: convertToAblDate(end),
        ablToken: accessBankToken,
        token: authanticatedUser?.token
      }
  
      dispatch(getCustomerStatement(tmpStat))
    }
  };

  const handleDatasetChange = (dataset) => {
    setActiveDataset(dataset);
  };

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-slate-500">
      <SideBar
        options={{
          toggleLogOutModal,
          toggleContactUsModal,
        }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 py-6 mx-auto">
        <div className="flex justify-between items-center">
                    <div>
                      {/* <h6 className="font-extrabold">
                        Income and Expenses Overview
                      </h6>
                      <p className="leading-normal text-sm">
                        <i className="fa fa-arrow-up text-lime-500"></i>
                        <span className="font-semibold">4% more</span> income
                        than last year.
                      </p> */}
                    </div>
                    <div className="flex items-center">
                      <label
                        htmlFor="account-select"
                        className="mr-2 text-sm font-semibold"
                      >
                        Account:
                      </label>
                      <select
                        id="account-select"
                        className="border border-gray-300 rounded px-2 py-1 text-sm"
                        value={dasAccount}
                        onChange={e => selectDashboardAccount(e.target.value)}
                      >
                        <option >{dasAccount?.accountNumber ? `${dasAccount?.accountNumber + ' ' + dasAccount?.currency}`:"Select Account"}</option>
                        {accounts?.accounts?.map((account, i) => (
                          <option key={i} value={`{"accountNumber": "${account?.accountNumber}", "currency": "${account?.currency}", "balance": "${account?.balance}", "internalAccountNumber": "${account?.internalAccountNumber}" }`} >
                            {account?.accountNumber + ' - ' + account?.currency}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
          <DashBoardStats  options={{account: accounts?.accounts, deposit, withdrawal, transactions: statement?.transactions, dasAccount }} />

          <div className="flex flex-wrap mt-6 -mx-3">
            <div className="w-full max-w-full px-3 mt-0 mb-6 lg:mb-0 lg:w-7/12 lg:flex-none">
              <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
                <div className="flex-auto p-4">
                  <div className="flex flex-wrap -mx-3">
                    <div className="max-w-full px-3 lg:w-1/2 lg:flex-none">
                      <div className="flex flex-col h-full">
                        <p className="pt-3 pb-4 font-semibold">
                          Secure Online Banking
                        </p>
                        <h5 className="font-bold">AccessBank Liberia</h5>
                        <p className="mb-12">
                          Experience secure and convenient banking with our
                          state-of-the-art online platform. Manage your
                          accounts, {' '}
                          {/* transfer funds,  */}
                           and access a wide range of
                          financial services anytime, anywhere.
                        </p>
                      </div>
                    </div>
                    <div className="max-w-full px-3 mt-12 ml-auto text-center lg:mt-0 lg:w-5/12 lg:flex-none">
                      <div className="h-full bg-gradient-to-tl from-primary to-primary-light rounded-xl">
                        <img
                          src="/assets/img/shapes/waves-white.svg"
                          className="absolute top-0 hidden w-1/2 h-full lg:block"
                          alt="waves"
                        />
                        <div className="relative flex items-center justify-center h-full">
                          <img
                            className="relative z-20 w-full h-full"
                            src="/assets/security.jpg"
                            alt="banking illustration"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full max-w-full px-3 lg:w-5/12 lg:flex-none">
              <div className="border-black/12.5 shadow-soft-xl relative flex h-full min-w-0 flex-col break-words rounded-2xl border-0 border-solid bg-white bg-clip-border p-4">
                <div
                  className="relative h-full overflow-hidden bg-cover rounded-xl"
                  style={{ backgroundImage: "url('/assets/img/faq-bg.jpg')" }}
                >
                  <span className="absolute top-0 left-0 w-full h-full bg-center bg-cover bg-gradient-to-tl from-primary to-primary-light opacity-80"></span>
                  <div className="relative z-10 flex flex-col flex-auto h-full p-4">
                    <h5 className="pt-1 mb-3 font-bold text-white">
                      Need Help? Check Our FAQs
                    </h5>
                    <p className="text-white">
                      If you have any questions or need assistance, our
                      comprehensive FAQ section is here to help. Find answers to
                      common queries and learn more about our services.
                    </p>
                    <Link
                      className="mt-auto mb-0 text-sm font-semibold leading-normal text-white group"
                      to="/faqs"
                    >
                      View FAQs
                      <i className="fas fa-arrow-right ease-bounce text-sm group-hover:translate-x-1.25 ml-1 leading-normal transition-all duration-200"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap mt-6 mb-10 -mx-3">
            <div className="w-full max-w-full px-3 mt-0 mb-6 lg:mb-0 lg:w-5/12 lg:flex-none">
              <div className="border-black/12.5 shadow-soft-xl relative z-20 flex min-w-0 flex-col break-words rounded-2xl border-0 border-solid bg-white bg-clip-border">
                <div className="flex-auto p-4">
                  <div className="py-4 pr-1 mb-4 bg-gradient-to-tl from-primary to-primary-light rounded-xl">
                    <div style={{ height: "350px" }}>
                      <BarChart info={{account: accounts?.accounts, deposit, withdrawal, transactions: statement?.transactions }} />
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="w-full max-w-full px-3 mt-0 lg:w-7/12 lg:flex-none">
              <div className="border-black/12.5 shadow-soft-xl relative z-20 flex min-w-0 flex-col break-words rounded-2xl border-0 border-solid bg-white bg-clip-border">
                <div className="border-black/12.5 mb-0 rounded-t-2xl border-b-0 border-solid bg-white p-6 pb-0">
                  <div className="flex justify-between items-center">
                    <div>
                      <h6 className="font-extrabold">
                        Deposits and Withdrawals Overview
                      </h6>
                      {/* <p className="leading-normal text-sm">
                        <i className="fa fa-arrow-up text-lime-500"></i>
                        <span className="font-semibold">4% more</span> income
                        than last year.
                      </p> */}
                    </div>
                    <div className="flex items-center">

                    </div>
                  </div>
                </div>
                <div className="flex-auto p-4">
                  <div style={{ height: "350px" }}>
                    <LineChart
                      selectedAccount={selectedAccount}
                      activeDataset={activeDataset}
                      onDatasetChange={handleDatasetChange}
                      options={{account: accounts?.accounts, deposit, withdrawal, transactions: statement.transactions }} 
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </main>
      <LogOutModal
        isOpen={isLogOutModalOpen}
        setIsOpen={setIsLogOutModalOpen}
      />

      {authanticatedUser?.login < 1 ? <SetNewPasswordModal options={{newPassOpen, setNewPassOpen}}/> : ''}


      <ContactUsModal
        isOpen={isContactUsModalOpen}
        setIsOpen={setIsContactUsModalOpen}
      />
    </div>
  );
};

export default Home;
